namespace('compass.hotel');

/*Hotel Name
Distance

Accordion
	Promotoions
	Hotel Description
	Amenities
	Driving Driections
	Airport Transportation
	Parking
<div id="accordion">
    <h3><a href="#">First header</a></h3>
    <div>First content</div>
    <h3><a href="#">Second header</a></h3>
    <div>Second content</div>
</div>


 */

compass.hotel.HotelDescriptionWidget = compass.defineWidget(function HotelDescriptionWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	var amenitiesIndex = 0;

	var onPeakPromotions = _settings.defaultPromotions;

	var _setupControls = this.setupControls = function() {
		me.find('#accordion').accordion({
			heightStyle: "content",
			navigation: true,
			collapsible: true
		});

		me.find('h4').click(function(evt) {
			evt.preventDefault();
			compass.GA.trackEvent("InfoTab", "View Description", evt.currentTarget.innerText);
		});
	};

	var _render = this.render = function(widgetElem) {
		widgetElem.append(me.drawAccordion());
		_setupControls();
	};
	this.drawAccordion = function(){
		var d = _d;
		var descriptions = _settings.hotelInfo;
		var promotions;
		var customPromos = [];
		var onPeakPromos = [];
		// sort promotions to have onpeak promos come first and then custom promos after
		_.each(descriptions.promotions, function(promo) {
			if (onPeakPromotions.includes(promo)) {
				onPeakPromos.push(promo);
			} else {
				customPromos.push(promo);
			}
		});
		promotions = onPeakPromos.concat(customPromos);
		_accordionHolder = d.div({id:'accordion', className:'descriptionAccordion'});
		var showEPSHotelInfo = descriptions.hotelInfo.showEPSHotelInfo;
		var affiliateType = descriptions.affiliateType;
		if (affiliateType === "none" || affiliateType === "GALILEO") {
			if (showEPSHotelInfo === "Y") {
			// if the hotel has been updated with Expedia data
				if(promotions.length !== 0){
					var _promotionsId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4( d.a({className:"accordionHeader", id: _promotionsId, href: 'javascript:;', tabindex: -1}, "Exclusive Promotions")));
					_promotionsHolder = d.div({
						className : 'accordionContentDiv hotelDescriptionPromotionsDiv', 'aria-labelledby': _promotionsId
					});
					for(var index = 0; index < promotions.length ; index++) {
						jQuery(_promotionsHolder).append(
							d.div({
								className : 'accordionSubContentDiv hotelDescriptionSinglePromotion'
							}, promotions[index] )
						);
					}
					jQuery(_accordionHolder).append(_promotionsHolder);
				}

				if(descriptions.hotelInfo.epsOverview !== ''){
					var _overviewId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _overviewId, href: 'javascript:;', tabindex: -1}, "Overview")),
						d.div({
							className: 'accordionContentDiv hotelOverviewHolderDiv', 'aria-labelledby': _overviewId
						},
							descriptions.hotelInfo.epsOverview)
					);
				}

				if(descriptions.amenities.length !== 0){
					var _hotelAmenitiesId = compass.generateId();
					var hotelAmenities = descriptions.amenities;
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _hotelAmenitiesId, href: 'javascript:;', tabindex: -1}, "Hotel Amenities")));
					_hotelAmenitiesHolder = d.div({
						className: 'accordionContentDiv hotelAmenitiesHolderDiv', 'aria-labelledby': _hotelAmenitiesId
					});
					hotelAmenitiesLength = hotelAmenities.length;
					if (hotelAmenitiesLength >= 2) {
						var amenitiesColumnLength = Math.ceil(hotelAmenitiesLength/2);
						if (showEPSHotelInfo === "Y") {
							hotelAmenities = hotelAmenities.filter(
								function(amenity) {
									return amenity.is_eps_controlled === "Y";
								}
							);
						}
						var leftColumn = hotelAmenities.slice(0, amenitiesColumnLength);
						var rightColumn = hotelAmenities.slice(amenitiesColumnLength, hotelAmenitiesLength);
						var _hotelAmenitiesLeftColumnId = compass.generateId();
						_leftColumnHolder = d.ul({
							className: 'accordionContentDiv hotelAmenitiesDiv hotelAmenitiesColumnHolder', 'aria-labelledby': _hotelAmenitiesLeftColumnId
						});
						for(var index = 0; index < leftColumn.length; index++) {
							jQuery(_leftColumnHolder).append(
								d.li({
									className: 'accordionSubContentDiv hotelAmenitiesSingleAmenity'
								}, leftColumn[index].name)
							);
						}
						var _hotelAmenitiesRightColumnId = compass.generateId();
						_rightColumnHolder = d.ul({
							className: 'accordionContentDiv hotelAmenitiesDiv hotelAmenitiesColumnHolder', 'aria-labelledby': _hotelAmenitiesRightColumnId
						});
						for(var index = 0; index < rightColumn.length; index++) {
							jQuery(_rightColumnHolder).append(
								d.li({
									className: 'accordionSubContentDiv hotelAmenitiesSingleAmenity'
								}, rightColumn[index].name)
							);
						}
						jQuery(_hotelAmenitiesHolder).append(
							d.div({
								className: 'accordionSubContentDiv hotelAmenitiesColumn'
							}, _leftColumnHolder),
							d.div({
								className: 'accordionSubContentDiv hotelAmenitiesColumn'
							}, _rightColumnHolder)
						);
					} else {
						jQuery(_hotelAmenitiesHolder).append(
							d.div({
								className: 'accordionSubContentDiv hotelAmenitiesDiv'
							}, hotelAmenities)
						);
					}
					jQuery(_accordionHolder).append(_hotelAmenitiesHolder);
				}

				if(descriptions.hotelInfo.businessAmenities !== ''){
					var _businessAmenitiesId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _businessAmenitiesId, href: 'javascript:;', tabindex: -1}, "Business Amenities")),
						d.div({
							className: 'accordionContentDiv hotelDescriptionBusinessAmenitiesDiv', 'aria-labelledby': _businessAmenitiesId
						},
							descriptions.hotelInfo.businessAmenities)
					);
				}

				if(descriptions.sustainabilityItems.length !== 0){
					var _hotelSustainabilityItemsId = compass.generateId();
					var hotelSustainabilityItems = descriptions.sustainabilityItems;
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _hotelSustainabilityItemsId, href: 'javascript:;', tabindex: -1}, "Sustainability")));
					var _hotelSustainabilityItemsList = d.div({
						className: 'hotelSustainabilityItemList', 'aria-labelledby': _hotelSustainabilityItemsId
					});
					var _sustainabilityItemsHolder = d.div(
						{className: 'accordionContentDiv hotelSustainabilityItemHolderDiv'},
						d.div("Hotel's sustainability initiatives are determined by a third party."),
						d.hr({className: 'hotelSustainabilityItemDivider'}),
						_hotelSustainabilityItemsList
					);
					hotelSustainabilityItemsLength = hotelSustainabilityItems.length;
					if (hotelSustainabilityItemsLength >= 2) {
						var sustainabilityColumnLength = Math.ceil(hotelSustainabilityItemsLength/2);
						var leftColumn = hotelSustainabilityItems.slice(0, sustainabilityColumnLength);
						var rightColumn = hotelSustainabilityItems.slice(sustainabilityColumnLength, hotelSustainabilityItemsLength);
						var _hotelSustainabilityItemsLeftColumnId = compass.generateId();
						_leftColumnHolder = d.ul({
							className: 'accordionContentDiv hotelSustainabilityItemDiv hotelSustainabilityItemColumnHolder', 'aria-labelledby': _hotelSustainabilityItemsLeftColumnId
						});
						for(var index = 0; index < leftColumn.length; index++) {
							jQuery(_leftColumnHolder).append(
								d.li({
									className: 'accordionSubContentDiv hotelSustainabilitySingleItem'
								}, leftColumn[index])
							);
						}
						var _hotelSustainabilityItemsRightColumnId = compass.generateId();
						_rightColumnHolder = d.ul({
							className: 'accordionContentDiv hotelSustainabilityItemsDiv hotelSustainabilityItemColumnHolder', 'aria-labelledby': _hotelSustainabilityItemsRightColumnId
						});
						for(var index = 0; index < rightColumn.length; index++) {
							jQuery(_rightColumnHolder).append(
								d.li({
									className: 'accordionSubContentDiv hotelSustainabilitySingleItem'
								}, rightColumn[index])
							);
						}
						jQuery(_hotelSustainabilityItemsList).append(
							d.div({
								className: 'accordionSubContentDiv hotelSustainabilityItemColumn'
							}, _leftColumnHolder),
							d.div({
								className: 'accordionSubContentDiv hotelSustainabilityItemColumn'
							}, _rightColumnHolder)
						);
					} else {
						jQuery(_hotelSustainabilityItemsList).append(
							d.div({
								className: 'accordionSubContentDiv hotelSustainabilityItemDiv'
							}, hotelSustainabilityItems)
						);
					}
					jQuery(_accordionHolder).append(_sustainabilityItemsHolder);
				}

				if(descriptions.hotelInfo.dining !== ''){
					var _diningId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _diningId, href: 'javascript:;', tabindex: -1}, "Dining")),
						d.div({
							className: 'accordionContentDiv hotelDescriptionDiningDiv', 'aria-labelledby': _diningId
						},
							descriptions.hotelInfo.dining)
					);
				}

				if(descriptions.hotelInfo.epsLocation !== ''){
					var _locationId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _locationId, href: 'javascript:;', tabindex: -1}, "Location")),
						d.div({
							className: 'accordionContentDiv hotelDescriptionLocationDiv', 'aria-labelledby': _locationId
						},
							descriptions.hotelInfo.epsLocation)
					);
				}

				if(descriptions.hotelInfo.attractions !== ''){
					var _attractionsId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _attractionsId, href: 'javascript:;', tabindex: -1}, "Attractions")),
						d.div({
							className: 'accordionContentDiv hotelDescriptionAttractionsDiv', 'aria-labelledby': _attractionsId
						},
							descriptions.hotelInfo.attractions)
					);
				}

				if(descriptions.hotelInfo.renovations !== ''){
					var _renovationsId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _renovationsId, href: 'javascript:;', tabindex: -1}, "Renovations")),
						d.div({
							className: 'accordionContentDiv hotelDescriptionRenovationsDiv', 'aria-labelledby': _renovationsId
						},
							descriptions.hotelInfo.renovations)
					);
				}

				if(descriptions.hotelInfo.nationalRatings !== ''){
					var _nationalRatingsId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _nationalRatingsId, href: 'javascript:;', tabindex: -1}, "National Ratings")),
						d.div({
							className: 'accordionContentDiv hotelDescriptionNationalRatingsDiv', 'aria-labelledby': _nationalRatingsId
						},
							descriptions.hotelInfo.nationalRatings)
					);
				}

			} else if(showEPSHotelInfo !== 'Y') {
			// if hotel has not been updated with Expedia data
				if(promotions.length !== 0){
					var _promotionsId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4( d.a({className:"accordionHeader", id: _promotionsId, href: 'javascript:;', tabindex: -1}, "Exclusive Promotions") ));
					_promotionsHolder = d.div({
						className : 'accordionContentDiv hotelDescriptionPromotionsDiv'
					});
					for(var index = 0; index < promotions.length ; index++) {
						jQuery(_promotionsHolder).append(
							d.div({
								className : 'accordionSubContentDiv hotelDescriptionSinglePromotion'
							}, promotions[index] )
						);
					}
					jQuery(_accordionHolder).append(_promotionsHolder);
				}

				if(descriptions.hotelInfo.description !== ''){
					var _hotelDescriptionId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _hotelDescriptionId, href: 'javascript:;', tabindex: -1}, "Hotel Description")),
						d.div({
							className: 'accordionContentDiv hotelDescriptionHotelDescriptionDiv', 'aria-labelledby': _hotelDescriptionId
						},
							descriptions.hotelInfo.description)
					);
				}

				if(descriptions.hotelInfo.hotelLocation !== ''){
					var _hotelLocationId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _hotelLocationId, href: 'javascript:;', tabindex: -1}, "Hotel Location")),
						d.div({
							className: 'accordionContentDiv hotelDescriptionHotelLocationDiv', 'aria-labelledby': _hotelLocationId
						},
							descriptions.hotelInfo.hotelLocation)
					);
				}

				if(descriptions.hotelInfo.driving !== ''){
					var _drivingDirectionsId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _drivingDirectionsId, href: 'javascript:;', tabindex: -1}, "Driving Directions")),
						d.div({
							className: 'accordionContentDiv hotelDescriptionHotelDirectionsDiv', 'aria-labelledby': _drivingDirectionsId
						},
							descriptions.hotelInfo.driving)
					);
				}

				if(descriptions.hotelInfo.airport !== ''){
					var _airTransportId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _airTransportId, href: 'javascript:;', tabindex: -1}, "Airport Transportation")),
						d.div({
							className: 'accordionContentDiv hotelDescriptionHotelAirportDiv', 'aria-labelledby': _airTransportId
						},
							descriptions.hotelInfo.airport)
					);
				}

				if(descriptions.hotelInfo.parking !== ''){
					var _parkingId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _parkingId, href: 'javascript:;', tabindex: -1}, "Parking")),
						d.div({
							className: 'accordionContentDiv hotelDescriptionHotelParkingDiv', 'aria-labelledby': _parkingId
						},
							descriptions.hotelInfo.parking)
					);
				}

				if(descriptions.amenities.length !== 0){
					hotelAmenities = descriptions.amenities.filter(
						function(amenity) {
							return amenity.is_eps_controlled !== "Y";
						}
					);
					amenitiesIndex = hotelAmenities.length;
					var _amenitiesId = compass.generateId();
					jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _amenitiesId, href: 'javascript:;', tabindex: -1}, "Amenities")));
					_amenitiesHolder = d.div({
							className : 'accordionContentDiv hotelDescriptionAmenitiesDiv', 'aria-labelledby': _amenitiesId
					});
					for(var index = 0; index < amenitiesIndex ; index++) {
	
						jQuery(_amenitiesHolder).append(
							d.div({
							className : 'accordionSubContentDiv hotelDescriptionSingleAmentiyType'
							}, hotelAmenities[index].name ),
							d.div({
							className : 'accordionSubContentDiv hotelDescriptionSingleAmentiyDescription'
							}, hotelAmenities[index].description )
	
						);
					}
					jQuery(_accordionHolder).append(_amenitiesHolder);
				}
			}
		} else if (affiliateType === "EAN"){
			// if hotel has not been updated by Nifi but is an Expedia hotel
			if(descriptions.EPSHotelInfo.amenities || descriptions.EPSHotelInfo.headline){
				var _amenitiesId = compass.generateId();
				jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _amenitiesId, href: 'javascript:;', tabindex: -1}, "Overview")));
				_overviewHolder = d.div({
					className: 'accordionContentDiv hotelOverviewHolderDiv', 'aria-labelledby': _amenitiesId
				});
				if(descriptions.EPSHotelInfo.amenities){
					jQuery(_overviewHolder).append(
						d.div({
							className: 'accordionSubContentDiv hotelOverviewDiv'
						}, descriptions.EPSHotelInfo.amenities)
					);
				}
				if(descriptions.EPSHotelInfo.headline) {
					jQuery(_overviewHolder).append(
						d.div({
							className: 'accordionSubContentDiv hotelHeadlineDiv'
						}, descriptions.EPSHotelInfo.headline)
					);
				}
				jQuery(_accordionHolder).append(_overviewHolder);
			}

			if(descriptions.EPSHotelInfo.hotel_amenities){
				var _hotelAmenitiesId = compass.generateId();
				jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _hotelAmenitiesId, href: 'javascript:;', tabindex: -1}, "Hotel Amenities")));
				_hotelAmenitiesHolder = d.div({
					className: 'accordionContentDiv hotelAmenitiesHolderDiv', 'aria-labelledby': _hotelAmenitiesId
				});

				hotelAmenitiesLength = descriptions.EPSHotelInfo.hotel_amenities.length;
				if (hotelAmenitiesLength >= 2) {
					var amenitiesColumnLength = Math.ceil(hotelAmenitiesLength/2);
					var leftColumn = descriptions.EPSHotelInfo.hotel_amenities.slice(0, amenitiesColumnLength);
					var rightColumn = descriptions.EPSHotelInfo.hotel_amenities.slice(amenitiesColumnLength, hotelAmenitiesLength);
					var _hotelAmenitiesLeftColumnId = compass.generateId();
					_leftColumnHolder = d.ul({
						className: 'accordionContentDiv hotelAmenitiesDiv hotelAmenitiesColumnHolder', 'aria-labelledby': _hotelAmenitiesLeftColumnId
					});
					for(var index = 0; index < leftColumn.length; index++) {
						jQuery(_leftColumnHolder).append(
							d.li({
								className: 'accordionSubContentDiv hotelAmenitiesSingleAmenity'
							}, leftColumn[index])
						);
					}
					var _hotelAmenitiesRightColumnId = compass.generateId();
					_rightColumnHolder = d.ul({
						className: 'accordionContentDiv hotelAmenitiesDiv hotelAmenitiesColumnHolder', 'aria-labelledby': _hotelAmenitiesRightColumnId
					});
					for(var index = 0; index < rightColumn.length; index++) {
						jQuery(_rightColumnHolder).append(
							d.li({
								className: 'accordionSubContentDiv hotelAmenitiesSingleAmenity'
							}, rightColumn[index])
						);
					}
					jQuery(_hotelAmenitiesHolder).append(
						d.div({
							className: 'accordionSubContentDiv hotelAmenitiesColumn'
						}, _leftColumnHolder),
						d.div({
							className: 'accordionSubContentDiv hotelAmenitiesColumn'
						}, _rightColumnHolder)
					);
				} else {
					jQuery(_hotelAmenitiesHolder).append(
						d.div({
							className: 'accordionSubContentDiv hotelAmenitiesDiv'
						}, descriptions.EPSHotelInfo.hotel_amenities)
					);
				}

				jQuery(_accordionHolder).append(_hotelAmenitiesHolder);
			}

			if(descriptions.EPSHotelInfo.business_amenities){
				var _businessAmenitiesId = compass.generateId();
				jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _businessAmenitiesId, href: 'javascript:;', tabindex: -1}, "Business Amenities")),
					d.div({
						className: 'accordionContentDiv hotelDescriptionBusinessAmenitiesDiv', 'aria-labelledby': _businessAmenitiesId
					},
						descriptions.EPSHotelInfo.business_amenities)
				);
			}

			if(descriptions.EPSHotelInfo.sustainability_items && descriptions.EPSHotelInfo.sustainability_items.length !== 0){
				var _hotelSustainabilityItemsId = compass.generateId();
				var hotelSustainabilityItems = descriptions.EPSHotelInfo.sustainability_items;
				jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _hotelSustainabilityItemsId, href: 'javascript:;', tabindex: -1}, "Sustainability")));
				var _hotelSustainabilityItemsList = d.div({
					className: 'hotelSustainabilityItemList', 'aria-labelledby': _hotelSustainabilityItemsId
				});
				var _sustainabilityItemsHolder = d.div(
					{className: 'accordionContentDiv hotelSustainabilityItemHolderDiv'},
					d.div("Hotel's sustainability initiatives are determined by a third party."),
					d.hr({className: 'hotelSustainabilityItemDivider'}),
					_hotelSustainabilityItemsList
				);
				hotelSustainabilityItemsLength = hotelSustainabilityItems.length;
				if (hotelSustainabilityItemsLength >= 2) {
					var sustainabilityColumnLength = Math.ceil(hotelSustainabilityItemsLength/2);
					var leftColumn = hotelSustainabilityItems.slice(0, sustainabilityColumnLength);
					var rightColumn = hotelSustainabilityItems.slice(sustainabilityColumnLength, hotelSustainabilityItemsLength);
					var _hotelSustainabilityItemsLeftColumnId = compass.generateId();
					_leftColumnHolder = d.ul({
						className: 'accordionContentDiv hotelSustainabilityItemDiv hotelSustainabilityItemColumnHolder', 'aria-labelledby': _hotelSustainabilityItemsLeftColumnId
					});
					for(var index = 0; index < leftColumn.length; index++) {
						jQuery(_leftColumnHolder).append(
							d.li({
								className: 'accordionSubContentDiv hotelSustainabilitySingleItem'
							}, leftColumn[index])
						);
					}
					var _hotelSustainabilityItemsRightColumnId = compass.generateId();
					_rightColumnHolder = d.ul({
						className: 'accordionContentDiv hotelSustainabilityItemsDiv hotelSustainabilityItemColumnHolder', 'aria-labelledby': _hotelSustainabilityItemsRightColumnId
					});
					for(var index = 0; index < rightColumn.length; index++) {
						jQuery(_rightColumnHolder).append(
							d.li({
								className: 'accordionSubContentDiv hotelSustainabilitySingleItem'
							}, rightColumn[index])
						);
					}
					jQuery(_hotelSustainabilityItemsList).append(
						d.div({
							className: 'accordionSubContentDiv hotelSustainabilityItemColumn'
						}, _leftColumnHolder),
						d.div({
							className: 'accordionSubContentDiv hotelSustainabilityItemColumn'
						}, _rightColumnHolder)
					);
				} else {
					jQuery(_hotelSustainabilityItemsList).append(
						d.div({
							className: 'accordionSubContentDiv hotelSustainabilityItemDiv'
						}, hotelSustainabilityItems)
					);
				}
				jQuery(_accordionHolder).append(_sustainabilityItemsHolder);
			}

			if(descriptions.EPSHotelInfo.rooms){
				var _roomsId = compass.generateId();
				jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _roomsId, href: 'javascript:;', tabindex: -1}, "Rooms")),
					d.div({
						className: 'accordionContentDiv hotelDescriptionRoomsDiv', 'aria-labelledby': _roomsId
					},
						descriptions.EPSHotelInfo.rooms)
				);
			}

			if(descriptions.EPSHotelInfo.dining){
				var _diningId = compass.generateId();
				jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _diningId, href: 'javascript:;', tabindex: -1}, "Dining")),
					d.div({
						className: 'accordionContentDiv hotelDescriptionDiningDiv', 'aria-labelledby': _diningId
					},
						descriptions.EPSHotelInfo.dining)
				);
			}

			if(descriptions.EPSHotelInfo.renovations){
				var _renovationsId = compass.generateId();
				jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _renovationsId, href: 'javascript:;', tabindex: -1}, "Renovations")),
					d.div({
						className: 'accordionContentDiv hotelDescriptionRenovationsDiv', 'aria-labelledby': _renovationsId
					},
						descriptions.EPSHotelInfo.renovations)
				);
			}

			if(descriptions.EPSHotelInfo.national_ratings){
				var _nationalRatingsId = compass.generateId();
				jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _nationalRatingsId, href: 'javascript:;', tabindex: -1}, "National Ratings")),
					d.div({
						className: 'accordionContentDiv hotelDescriptionNationalRatingsDiv', 'aria-labelledby': _nationalRatingsId
					},
						descriptions.EPSHotelInfo.national_ratings)
				);
			}

			if(descriptions.EPSHotelInfo.location){
				var _locationId = compass.generateId();
				jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _locationId, href: 'javascript:;', tabindex: -1}, "Location")),
					d.div({
						className: 'accordionContentDiv hotelDescriptionLocationDiv', 'aria-labelledby': _locationId
					},
						descriptions.EPSHotelInfo.location)
				);
			}

			if(descriptions.EPSHotelInfo.attractions){
				var _attractionsId = compass.generateId();
				jQuery(_accordionHolder).append(d.h4(d.a({className:"accordionHeader", id: _attractionsId, href: 'javascript:;', tabindex: -1}, "Attractions")),
					d.div({
						className: 'accordionContentDiv hotelDescriptionAttractionsDiv', 'aria-labelledby': _attractionsId
					},
						descriptions.EPSHotelInfo.attractions)
				);
			}
		}


		return _accordionHolder;
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultHotelDescriptionWidgetWUID',
	widgetName : 'HotelDescriptionWidget',
	hotelInfo : {
		promotions : [ ]
	}
});

